import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import { UnderlinedButton, Tabs, Product } from '../components'
import Basket from '../images/basket.png'
import FbReview from '../images/fb_reviews.png'
import GoogleReview from '../images/google_review.png'
import Slash from '../images/slash.png'
import Images from '../images'
import { getAdminSettings } from '../services/AdminSettings'
import { getNovaPonuda, getPopularniProizvodi } from '../store/Actions/Products'
import {
  getNovaPonudaSelector,
  getPopularniProizvodiSelector,
} from '../store/Selectors/Products'

class Home extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      adminSettings: null,
    }
  }

  async componentDidMount() {
    const adminSettingsResult = await getAdminSettings()
    if (adminSettingsResult.isOk) {
      this.setState({ adminSettings: adminSettingsResult.data })
    }

    // Call novaPonuda and Popular to store in redux - use it in selectors
    this.props.getNovaPonuda()
    this.props.getPopularniProizvodi()
  }

  render() {
    const dostavaSarajevo = this.state.adminSettings?.dostava?.sarajevo
    const dostavaZenica = this.state.adminSettings?.dostava?.zenica
    const dostavaDrugiGradovi = this.state.adminSettings?.dostava?.drugiGradovi

    return (
      <>
        <Navbar />
        <section className="section" id="homeWelcomeSection">
          <div className="container">
            <img
              src={Basket}
              className="basket-image"
              alt="Basket background"
            />
            <div className="left">
              <div className="left-box">
                <h1 className="title">
                  DOBRODOŠLI U<br />
                  KORPU ZDRAVLJA!
                </h1>
                <p>{`Kupite najbolje domaće proizvode jednostavno preko interneta. Uvijek svježe. Na kućni prag.`}</p>
                <div className="buttons">
                  <UnderlinedButton
                    txt="Započni narudžbu"
                    linkTo="/ponuda"
                    isGreen={true}
                  />

                  <UnderlinedButton
                    txt="Više o Korpi zdravlja"
                    linkTo="#zastoKorpaSection"
                    isTransparent={true}
                    handleClick={() =>
                      document
                        .getElementById('zastoKorpaSection')
                        .scrollIntoView({ behavior: 'smooth' })
                    }
                  />
                </div>
              </div>
            </div>
            <div className="reviews">
              <img src={FbReview} className="review" alt="Facebook Review" />
              <img src={Slash} className="review" alt="Slash" />
              <img src={GoogleReview} className="review" alt="Google Review" />
            </div>
          </div>
        </section>

        <section className="section" id="zastoKorpaSection">
          <div className="container">
            <div className="subtitleDiv">
              <h2 className="title has-text-centered">ZAŠTO KORPA ZDRAVLJA?</h2>
            </div>

            <div className="columns is-multiline">
              <div className="column is-4">
                <div>
                  <img src={Images.Illustration1} alt="Illustration" />
                  <p className="has-text-centered mt-5">{`Bolji ukus i više nutrijenata za tebe i tvoju porodicu. Prirodna hrana za zdravo tijelo i duh.`}</p>
                </div>{' '}
              </div>
              <div className="column is-4">
                <div>
                  <img src={Images.Illustration2} alt="Illustration" />
                  <p className="has-text-centered mt-5">{`Najveći online izbor prirodnih namirnica u BiH.  Od igle do kupusa. `}</p>
                </div>{' '}
              </div>
              <div className="column is-4">
                <div>
                  <img src={Images.Illustration3} alt="Illustration" />
                  <p className="has-text-centered mt-5">{`Pouzdana dostava širom BiH. Sa sela na tvoj kućni prag.  Čak i na zadnji sprat.`}</p>
                </div>{' '}
              </div>
              <div className="column is-4">
                <div>
                  <img src={Images.Illustration4} alt="Illustration" />
                  <p className="has-text-centered mt-5">{`Porodični smo biznis koji godinama usavršava proizvode i metode. Radimo ono sto najviše volimo.`}</p>
                </div>{' '}
              </div>
              <div className="column is-4">
                <div>
                  <img src={Images.Illustration5} alt="Illustration" />
                  <p className="has-text-centered mt-5">{`Vođeni osnovnim moralnim principima brinemo o našim kupcima, koje doživljavamo kao širu porodicu.`}</p>
                </div>{' '}
              </div>
              <div className="column is-4">
                <div>
                  <img src={Images.Illustration6} alt="Illustration" />
                  <p className="has-text-centered mt-5">{`Vjerujemo u  ljepše sutra. Kupovinom podržavate male proizvođace u BiH i brinete o ekologiji naše zemlje i planete.`}</p>
                </div>{' '}
              </div>
            </div>

            <div className="shop-button">
              <UnderlinedButton
                txt="Započni narudžbu"
                linkTo="/ponuda"
                isOrange={true}
              />
            </div>
          </div>
        </section>

        <section className="section" id="kakoFunkcionisuNarudzbe">
          <div className="container">
            <div className="subtitleDiv">
              <h2 className="subtitle">
                KAKO FUNKCIONIŠU
                <br />
                NARUDŽBE?
              </h2>
            </div>

            <div className="columns">
              <div className="column is-3">
                <div>
                  <img
                    src={Images.KakoFunkcionisu1}
                    alt="Kako funkcionisu narudzbe?"
                  />
                  <p className="has-text-centered">01-narucite u shopu</p>
                </div>
              </div>
              <div className="column is-3">
                <div>
                  <img
                    src={Images.KakoFunkcionisu2}
                    alt="Kako funkcionisu narudzbe?"
                  />
                  <p className="has-text-centered">02-Beremo i pakujemo</p>
                </div>
              </div>
              <div className="column is-3">
                <div>
                  <img
                    src={Images.KakoFunkcionisu3}
                    alt="Kako funkcionisu narudzbe?"
                  />
                  <p className="has-text-centered">
                    03-dostavljamo na kucni prag
                  </p>
                </div>
              </div>
              <div className="column is-3">
                <div>
                  <img
                    src={Images.KakoFunkcionisu4}
                    alt="Kako funkcionisu narudzbe?"
                  />
                  <p className="has-text-centered">
                    04-povrat ambalaze dostavljacu
                  </p>
                </div>
              </div>
            </div>

            <div className="subtitleDiv">
              <h3 className="subtitle">Instrukcije za pojedinačne regije</h3>
            </div>

            <Tabs>
              <div label="Sarajevo, Ilijaš i Visoko">
                {dostavaSarajevo?.length > 0 &&
                  dostavaSarajevo.map((dostava) => {
                    return dostava?.Vrijednost && <p>{dostava?.Vrijednost}</p>
                  })}
              </div>
              <div label="Zenica, Kakanj">
                {dostavaZenica?.length > 0 &&
                  dostavaZenica.map((dostava) => {
                    return <p>{dostava?.Vrijednost}</p>
                  })}
              </div>
              <div label="Ostatak BiH">
                {dostavaDrugiGradovi?.length > 0 &&
                  dostavaDrugiGradovi.map((dostava) => {
                    return <p>{dostava?.Vrijednost}</p>
                  })}
              </div>
            </Tabs>

            <div className="shop-button">
              <UnderlinedButton
                txt="Započni narudžbu"
                linkTo="/ponuda"
                isGreen={true}
              />
            </div>
          </div>
        </section>

        <section className="section" id="nasaPrica">
          <div className="container">
            <div className="columns">
              <div className="column is-6">
                <h3>Zašto naše namirnice?</h3>
                <p>
                  Mi vraćamo namirnicama davno izgubljeni miris, okus i
                  kvalitet. Naši kooperanti i mi razvijamo prirodne metode
                  uzgoja hrane u ekološki prihvatljivom okruženju. Sigurna veza
                  sa malim proizvođačima. Namirnice proizvedene sa mnogo ljubavi
                  i požrtvovanosti. Hranu koju proizvodimo za Vas i sami jedemo.
                  Nasa hrana je bogatija vitaminima i mineralima zbog samog
                  načina uzgoja.
                </p>
              </div>
              <div className="column is-6">
                <img
                  src={Images.ZastoNaseNamirnice}
                  alt="Zasto nase namirnice?"
                />
              </div>
            </div>

            <div className="columns">
              <div className="column is-6">
                <img src={Images.NasaPrica} alt="Zasto nase namirnice?" />
              </div>
              <div className="column is-6">
                <h3>Naša priča</h3>
                <p>
                  Temelj zdravog života je zdrava ishrana, zato smo mi tu da ti
                  pomognemo uvrstiti zdravu hranu u tvoj jelovnik. Organska
                  hrana je hrana proizvedena koristeći prirodne metode koje ne
                  uključuju savremene vještačke dodatke kao npr. pesticide i
                  hemijska đubriva, ne sadrži genetski modificirane organizme i
                  nije tretirana.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="section" id="poznatoIz">
          <div className="container">
            <div className="subtitleDiv">
              <h3 className="subtitle">Poznato iz:</h3>
            </div>
            <div className="images">
              <div className="image-container">
                <img src={Images.FTV} alt="Korpa zdravlja - FTV" />
              </div>
              <div className="image-container">
                <img src={Images.Bonjour} alt="Korpa zdravlja - Bonjour" />
              </div>
              <div className="image-container">
                <img
                  src={Images.DobreKalorije}
                  alt="Korpa zdravlja - Dobre kalorije"
                />
              </div>
            </div>

            <div className="shop-button">
              <UnderlinedButton
                txt="Započni narudžbu"
                linkTo="/ponuda"
                isGreen={true}
              />
            </div>
          </div>
        </section>

        <section className="section" id="staKazuKupci">
          <div className="container">
            <div className="subtitleDiv">
              <h3 className="subtitle">Šta kažu naši kupci</h3>
            </div>

            <div className="columns">
              <div className="column is-4">
                <div className="user-wrapper">
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Phasellus ac porttitor nisi. Sed id dolor enim. Etiam ut leo
                    nec tellus tempor blandit. Vestibulum non ex scelerisque,
                    consectetur mi eu.
                  </p>
                  <div className="user">
                    <img
                      src={Images.User1}
                      alt="Korpa zdravlja - Sta kazu kupci"
                    />
                    <span>Lorem Ipsum</span>
                  </div>
                </div>
              </div>
              <div className="column is-4">
                <div className="user-wrapper">
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Phasellus ac porttitor nisi. Sed id dolor enim. Etiam ut leo
                    nec tellus tempor blandit. Vestibulum non ex scelerisque,
                    consectetur mi eu.
                  </p>
                  <div className="user">
                    <img
                      src={Images.User1}
                      alt="Korpa zdravlja - Sta kazu kupci"
                    />
                    <span>Lorem Ipsum</span>
                  </div>
                </div>
              </div>
              <div className="column is-4">
                <div className="user-wrapper">
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Phasellus ac porttitor nisi. Sed id dolor enim. Etiam ut leo
                    nec tellus tempor blandit. Vestibulum non ex scelerisque,
                    consectetur mi eu.
                  </p>
                  <div className="user">
                    <img
                      src={Images.User1}
                      alt="Korpa zdravlja - Sta kazu kupci"
                    />
                    <span>Lorem Ipsum</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="section" id="proizvodiSection">
          <div className="container">
            <div className="columns">
              {/* Novo u ponudi */}
              <div className="column is-6">
                <div className="subtitleDiv">
                  <h3>Novo u ponudi</h3>
                </div>
                <div className="columns is-multiline">
                  {this.props.novaPonuda.map((product) => {
                    const isProductInCart = this.props.productsInCart.find(
                      (x) => x.proizvodID === product.proizvodID
                    )
                    return (
                      <div
                        className="column is-6 is-4-widescreen inner-column"
                        key={product.proizvodID}
                      >
                        <Product
                          key={product.proizvodID}
                          product={product}
                          handleOnClick={() => {}}
                          isProductInCart={isProductInCart}
                          showSuccessMessage={true}
                          hideDescription={true}
                        />
                      </div>
                    )
                  })}
                </div>
              </div>

              {/*Popularni proizvodi */}
              <div className="column is-6">
                <div className="subtitleDiv">
                  <h3>Popularni proizvodi</h3>
                </div>
                <div className="columns is-multiline">
                  {this.props.popularniProizvodi.map((product) => {
                    const isProductInCart = this.props.productsInCart.find(
                      (x) => x.proizvodID === product.proizvodID
                    )
                    return (
                      <div
                        className="column is-6 is-4-widescreen inner-column"
                        key={product.proizvodID}
                      >
                        <Product
                          key={product.proizvodID}
                          product={product}
                          handleOnClick={() => {}}
                          isProductInCart={isProductInCart}
                          showSuccessMessage={true}
                          hideDescription={true}
                        />
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  token: state.authentication,
  novaPonuda: getNovaPonudaSelector(state),
  popularniProizvodi: getPopularniProizvodiSelector(state),
  productsInCart: state.products.productsInCart,
})

const mapDispatchToProps = {
  getPopularniProizvodi,
  getNovaPonuda,
}

export default connect(mapStateToProps, mapDispatchToProps)(Home)
